var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { debounce } from 'lodash-es';
import Component from 'navigation/component/Component';
import capency from 'helpers/capency';
import browser from 'helpers/browser';
import validators from '../form/components/validators';
var CapencyField = /** @class */ (function (_super) {
    __extends(CapencyField, _super);
    function CapencyField(el, refs) {
        var _this = _super.call(this, el) || this;
        Object.defineProperty(_this, "streetInput", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(_this, "streetField", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(_this, "suggestionsDiv", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(_this, "suggestions", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        // add missing types
        Object.defineProperty(_this, "_loading", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(_this, "focused", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(_this, "country", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(_this, "focusOut", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: function (event) {
                _this.focused = false;
                setTimeout(function () {
                    _this.suggestionsDiv.classList.remove('opened');
                }, 200);
            }
        });
        Object.defineProperty(_this, "onInputOrFocus", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: function (event) {
                var search = _this.streetInput.value;
                _this.focused = true;
                if (event.inputType !== undefined)
                    _this.emit('input');
                if (_this.suggestions)
                    _this.suggestionsDiv.classList.toggle('opened', true);
                if (event.inputType === 'insertText') {
                    if (search && search.length > 5) {
                        _this.loading = true;
                        _this.capencySearch(search);
                    }
                    else {
                        _this.loading = false;
                    }
                }
            }
        });
        Object.defineProperty(_this, "capencySearch", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: debounce(function (query) { return __awaiter(_this, void 0, void 0, function () {
                var request, response;
                var _a, _b;
                return __generator(this, function (_c) {
                    switch (_c.label) {
                        case 0: return [4 /*yield*/, capency.searchAddress(query, this.country)];
                        case 1:
                            request = _c.sent();
                            return [4 /*yield*/, request.json()];
                        case 2:
                            response = _c.sent();
                            if ((_a = response.body) === null || _a === void 0 ? void 0 : _a.addresses)
                                this.updateCapencySuggestions((_b = response.body) === null || _b === void 0 ? void 0 : _b.addresses.address.sort(function (a, b) { return parseInt(a.qualityCode) - parseInt(b.qualityCode); }));
                            this.loading = false;
                            return [2 /*return*/];
                    }
                });
            }); }, 500)
        });
        Object.defineProperty(_this, "onSuggestionClick", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: function (event) {
                var info = JSON.parse(event.currentTarget.getAttribute('data-info'));
                _this.emit('select', _this.extractCapencyAddress(info));
                _this.updateCapencySuggestions();
                browser.waitRepaint(function () {
                    _this.suggestionsDiv.classList.toggle('opened', false);
                    _this.streetInput.blur();
                });
                _this.loading = false;
            }
        });
        Object.defineProperty(_this, "extractCapencyAddress", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: function (addressInfo) {
                var object = {};
                var streetName = addressInfo.streetName, streetNumber = addressInfo.streetNumber, postalCode = addressInfo.postalCode, locality = addressInfo.locality, buildingName = addressInfo.buildingName, countryCode = addressInfo.countryCode;
                if (!object.address || !validators.street.isValidSync(object.address)) {
                    if (streetName && streetNumber)
                        object.address = "".concat(streetNumber, " ").concat(streetName);
                    else if (streetName)
                        object.address = streetName;
                }
                object.address2 = buildingName || null;
                object.city = locality;
                object.country = countryCode.slice(0, 2);
                object.postcode = postalCode;
                object.phone_code = object.country;
                return object;
            }
        });
        _this.parseForm();
        return _this;
    }
    Object.defineProperty(CapencyField.prototype, "loading", {
        get: function () {
            return this._loading;
        },
        set: function (value) {
            this.streetInput.parentElement.classList.toggle('loading', value);
            this._loading = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CapencyField.prototype, "initialized", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            _super.prototype.initialized.call(this);
        }
    });
    Object.defineProperty(CapencyField.prototype, "parseForm", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            this.streetInput = this.el;
            this.streetField = this.streetInput.parentElement.parentElement;
            this.streetField.classList.add('with-suggestions');
            this.suggestionsDiv = document.createElement('div');
            this.suggestionsDiv.className = 'field__suggestions';
            this.streetField.appendChild(this.suggestionsDiv);
        }
    });
    Object.defineProperty(CapencyField.prototype, "bindEvents", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (add) {
            if (add === void 0) { add = true; }
            var method = add ? 'addEventListener' : 'removeEventListener';
            this.el[method]('focusin', this.onInputOrFocus);
            this.el[method]('blur', this.focusOut);
            this.streetInput[method]('input', this.onInputOrFocus);
        }
    });
    Object.defineProperty(CapencyField.prototype, "clearSuggestions", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            var _this = this;
            browser.waitRepaint(function () {
                _this.suggestions && _this.suggestions.forEach(function (div) {
                    div.removeEventListener('click', _this.onSuggestionClick);
                });
                _this.suggestions = null;
            });
        }
    });
    Object.defineProperty(CapencyField.prototype, "updateCapencySuggestions", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (suggestions) {
            var _this = this;
            if (!suggestions)
                return;
            // this.clearSuggestions()
            this.suggestionsDiv.classList.toggle('opened', this.focused);
            this.suggestionsDiv.innerHTML = '';
            this.suggestions = suggestions.map(function (suggestion) {
                var streetName = suggestion.streetName, streetNumber = suggestion.streetNumber, postalCode = suggestion.postalCode, locality = suggestion.locality, buildingName = suggestion.buildingName;
                var button = document.createElement('button');
                button.type = 'button';
                button.className = 'field__suggestion';
                var label = "".concat(streetNumber || '', " ").concat(streetName || '', ", ").concat(postalCode || '', " ").concat(locality || '');
                var description = buildingName ? "".concat(buildingName) : '';
                suggestion.label = label;
                suggestion.description = description;
                button.setAttribute('data-info', JSON.stringify(suggestion));
                button.addEventListener('click', _this.onSuggestionClick);
                var alreadyTyped = _this.el.value;
                var remaining;
                if (label.toLowerCase().includes(alreadyTyped.toLowerCase())) {
                    remaining = label.slice(alreadyTyped.length);
                }
                else {
                    remaining = label;
                    alreadyTyped = '';
                }
                button.innerHTML = "\n        <h5 class=\"field__suggestion-title\"><span class=\"field__suggestion__already-typed\">".concat(alreadyTyped, "</span>").concat(remaining, "</h5>\n        ").concat(description ? "<p class=\"field__suggestion-description\">".concat(description, "</p>") : '', "\n      ");
                _this.suggestionsDiv.appendChild(button);
                return button;
            });
        }
    });
    Object.defineProperty(CapencyField.prototype, "flush", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            this.clearSuggestions();
            _super.prototype.flush.call(this);
        }
    });
    return CapencyField;
}(Component));
export default CapencyField;
